export default __webpack_public_path__ + "static/media/experiencias_voluntarias.dc2e13d1.svg";